var translationKey = 'faqs.description';
var dicks = {
    drawerActionButton: {
        text: 'drawerActionButton.dicksDrawerActionButtonText',
        link: 'https://www.dickssportinggoods.com/MyAccount/AccountSummary'
    },
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    es: {
        termsAndConditionsLink: 'https://www.dickssportinggoods.com/s/score-card-terms'
    },
    en: {
        termsAndConditionsLink: 'https://www.dickssportinggoods.com/s/score-card-terms'
    },
    howToEarnPointsHeader: '',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationViewPrintKey: null,
    PRIVATE_LABEL: {
        actionButton: null,
        banner: 'dsg-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    },
    DUAL_CARD: {
        actionButton: null,
        banner: 'dsg-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    }
};
export default dicks;
